import React, { ReactNode, useState } from 'react';

import { BookingContext } from './bookingContext';

interface BookingProviderProps {
  children: ReactNode;
  initialBooking: ArrivalBooking;
}

export const BookingProvider = ({
  children,
  initialBooking,
}: BookingProviderProps) => {
  const [booking, setBooking] = useState<ArrivalBooking>(initialBooking);

  const handleTransportUpdate = (body: UpdateBookingTransportBody) => {
    setBooking((prev) => ({
      ...prev,
      ...body,
    }));
  };

  const handleDateUpdate = (body: UpdateBookingDateBody) => {
    setBooking((prev) => ({
      ...prev,
      ...body,
    }));
  };

  const handleUpsertParticipants = (saved: UpsertParticipantsResponse) => {
    setBooking((prev) => ({
      ...prev,
      childNumber: saved.childNumber,
      toddlersNumber: saved.toddlersNumber,
      users: saved.participants,
    }));
  };

  const handleCancel = () => {
    setBooking((prev) => ({
      ...prev,
      isCancelled: true,
    }));
  };

  const value = {
    booking,
    handleTransportUpdate,
    handleDateUpdate,
    handleUpsertParticipants,
    handleCancel,
  };

  return (
    <BookingContext.Provider value={value}>{children}</BookingContext.Provider>
  );
};
